import { Component, OnInit, Input } from '@angular/core'
import { AuthenticationService } from '../../_services/authentication.service'
import { RequestsService } from 'src/app/_shared/services/requests.service'

declare var jQuery: any

@Component({
  selector: 'app-smart-diagnosis-pest-component',
  templateUrl: './smart-diagnosis-pest.component.html',
  styleUrls: ['./smart-diagnosis-pest.component.scss'],
})
export class SmartDiagnosisPestComponent implements OnInit {
  constructor(
    private requestService: RequestsService,
    private authenticationService: AuthenticationService
  ) {}

  @Input() type
  model: any = {}
  loading: boolean
  selector: string
  deleteDiagnosisloading: boolean
  diagnosisViewData: object
  deleteDiagnosisSuccess: boolean
  createAgroInfoisSuccess: boolean
  country_id: string
  editSmartInfoisSuccess: boolean
  editError: boolean
  showFilter = true
  page = 1
  count = 10
  data: []
  message: string
  category: string
  diagnosisId: string
  diagnosisData: object
  diagnosisDeleteData: object
  diagnosisAction: string
  modalId: string
  editInfoData: object
  submitted = false
  crops: any
  selectedCrops: any
  searchItem: string
  selectCrop = []
  selectDisease = []
  selectedName: any
  namesToSelect = []
  explanationTitle: string
  symptoms: string
  parts: any

  requiredField: any = {
    control: false,
    explanation: false,
    photo: false,
  }

  selectedImage: File = null
  changeImage(event) {
    this.selectedImage = <File>event.target.files[0]
  }

  quillConfig = {
    toolbar: [
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['bold', 'italic', 'underline'],
      [{ header: 1 }, { header: 2 }],
      ['clean'],
    ],
  }

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country_id } = currentUser
    this.country_id = country_id
    this.parts = ['Leaves', 'Flowers', 'Whole plant', 'Stem', 'Pest', 'Fruit']
    this.setCategory()
    this.getCrops()
    this.loadDiagnosis()
  }

  setCategory() {
    this.category = this.type === 'Pests' ? 'pest' : 'disease'
    this.explanationTitle = this.category === 'pest' ? 'effects' : 'symptoms'
  }

  loadDiagnosis(): void {
    this.loading = true
    this.requestService
      .dash_get(`smart-diagnosis/${this.category}`, null)
      .subscribe(
        (res) => {
          this.loading = false
          this.data = res.data
          let crops = []
          let names = []
          res.data
            ? res.data.map((each) => {
                names.push({ label: each.name, value: each.name })
                crops.push({ label: each.crop, value: each.crop })
              })
            : null
          this.namesToSelect = names
          this.selectCrop = crops.filter(
            (value, index, array) =>
              !array.filter(
                (v, i) =>
                  JSON.stringify(value) == JSON.stringify(v) && i < index
              ).length
          )
        },
        (err) => {
          this.loading = false
          this.message = err.error
        }
      )
  }

  setDiagnosisView(data: object): void {
    this.diagnosisViewData = data
  }

  getCrops() {
    this.loading = true
    this.requestService
      .dash_get(`enterprises/${this.country_id}`, null)
      .subscribe((res) => {
        this.loading = false
        this.crops = res
      })
  }

  handleSubmit(createDiagnosisForm) {
    this.submitted = true
    const formData = new FormData()
    formData.append('name', createDiagnosisForm.name)
    formData.append('crop', createDiagnosisForm.crop)
    formData.append('explanation', createDiagnosisForm.explanation)
    formData.append('weight', createDiagnosisForm.weight)
    formData.append('parts', createDiagnosisForm.part)

    if (this.selectedImage) {
      formData.append('photo', this.selectedImage, this.selectedImage.name)
    }
    this.postDiagnosis(formData)
  }

  postDiagnosis(data: object) {
    this.loading = true
    this.requestService
      .dash_putWithImage(`smart-diagnosis/${this.category}`, data)
      .subscribe(
        (res) => {
          this.loading = false
          this.message = res.message
          this.createAgroInfoisSuccess = res.success
          // form.reset();
          this.loadDiagnosis()
        },
        (err) => {
          const { error } = err
          this.loading = false
          this.message = error.error
        }
      )
  }

  resetModal() {
    // this.modal.hide();
    jQuery('#diagnosisForm').trigger('reset')
    // jQuery('#agroModal').modal('hide');
    this.createAgroInfoisSuccess = false
    this.selectedImage = <File>null
    // this.serverError = false;
  }

  clearErrorMessage(input) {
    if (input.name === 'explanation') {
      this.requiredField.explanation = false
    } else if (input.name === 'control') {
      this.requiredField.control = false
    }
  }

  getDisease() {
    this.searchItem = jQuery('#diagnosisCrop option:selected').text()
    console.log(this.searchItem)
    this.disease(this.searchItem)
  }
  getEditDisease() {
    this.searchItem = jQuery('#selectedCrop option:selected').text()
    // console.log(this.searchItem);
    this.disease(this.searchItem)
  }
  disease(name: string) {
    // if (name != undefined){}
    this.loading = true
    this.requestService
      .dash_get(`smart-diagnosis/getPest?crop=${name}`, null)
      .subscribe((res) => {
        this.loading = false
        this.selectDisease = res.data
      })
  }

  setDiagnosisAction(data: object) {
    this.editInfoData = data
  }

  handleEdit(updateInputForm, id) {
    this.loading = true
    const form = updateInputForm
    const URL = `smart-diagnosis/${this.category}/${id}`
    let formData = new FormData()

    formData.append('crop', form.crop)
    formData.append('name', form.name)
    formData.append('parts', form.part)
    formData.append('explanation', form.explanation)
    formData.append('weight', form.weight)
    if (this.selectedImage)
      formData.append('photo', this.selectedImage, this.selectedImage.name)
    this.requestService.dash_putWithImage(URL, formData).subscribe(
      (response) => {
        this.submitted = true
        this.loading = true
        if (response.success) {
          this.editSmartInfoisSuccess = true
          this.loadDiagnosis()
        } else if (!response.success) {
          this.loading = false
          this.message = response.message
          this.editError = true
        }

        // this.message = response.message;
        // this.successModal = true;
        // this.reloadInputs();
      },
      (error) => {
        this.loading = false
        this.message = 'Some error occurred. Please try again'
        this.editError = true
      }
    )
  }

  resetEditModal() {
    // this.modal.hide();
    jQuery('#editSmartModal').modal('hide')
    this.editSmartInfoisSuccess = false
    this.editError = false
    this.selectedImage = <File>null
  }

  deleteInfoDetails(data: object) {
    this.diagnosisDeleteData = data
  }

  deleteDiagnosis(id: string): void {
    this.deleteDiagnosisloading = true
    this.requestService
      .dash_delete(id, `smart-diagnosis/${this.category}`)
      .subscribe(
        (res) => {
          this.deleteDiagnosisloading = false
          this.deleteDiagnosisSuccess = true
          this.loadDiagnosis()
          this.message = 'Diagnosis information deleted successfully'
        },
        (err) => {
          this.deleteDiagnosisloading = false
          this.deleteDiagnosisSuccess = false
          if (err.status === 404) {
            this.message = 'Diagnosis information not found!'
          } else {
            this.message = 'Some error occurred. Please try again'
          }
        }
      )
  }

  resetDeleteModal() {
    // this.modal.hide();
    jQuery('#deleteModal').modal('hide')
    this.deleteDiagnosisSuccess = false
    this.message = ''
  }
  partToHandle() {
    this.selector = jQuery('#diagnosisPart option:selected').val()
    console.log(this.selector)
    if (this.selector === 'Pest') {
      this.explanationTitle = 'appearance'
    } else {
      this.setCategory()
    }
  }
}
